import React from "react";
import AllPvHistory from "../../sub-treasury/pv-collection/AllPvHistory";

const MdaPVTracking = () => {
  return <AllPvHistory mdaType="self-sustaining" />;
};

export default MdaPVTracking;
